import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { finalize } from 'rxjs';
import { FileUpload } from '../fileupload';

@Component({
  selector: 'app-form-upload-multiple',
  templateUrl: './form-upload-multiple.component.html',
  styleUrls: ['./form-upload-multiple.component.scss'],
  inputs: ['idBot', 'botName', 'uploadfilePath', 'imagelink', 'showSize', 'ShowAlt', 'ShowCardURL', 'infoImage', 'showcardURL', 'editMode', 'isNew', 'hideUploadUI']
})
export class FormUploadMultipleComponent implements OnInit {
  hideUploadUI = false;
  showcardURL
  selectedFiles!: FileList;
  currentFileUpload!: FileUpload;
  progress: { percentage: number } = { percentage: 0 };
  botImageURL!: boolean;
  download!: boolean;
  downloadURL: any;
  showSize;
  uploadfilePath;
  infoImage
  link: any;
  editMode
  image;
  imagelink: any;
  idBot;
  botName;
  isNew;
  ShowAlt;
  showURL = false
  showALTValue = false
  ShowCardURL
  @Output() urlImageCard = new EventEmitter();
  @Output() showURLInput = new EventEmitter();
  @Output() showCardUrlInput = new EventEmitter();

  @Output() showALTInput = new EventEmitter();
  showCardUrl = false;
  isUploading: boolean = false;

  constructor(
    private storage: AngularFireStorage,
  ) { }

  ngOnInit() {
  }
  URLInput() {
    this.showURL = !this.showURL
    this.showURLInput.emit(this.showURL);
  }
  cardUrlInput(event?: any) {
    if (event) {
      this.showCardUrl = event.checked;
    } else {
      this.showCardUrl = !this.showCardUrl;
    }
    this.showCardUrlInput.emit(this.showCardUrl);
  }
  ALTInput() {
    this.showALTValue = !this.showALTValue
    this.showALTInput.emit(this.showALTValue);
  }

  selectFile(event) {
    this.selectedFiles = event.target.files;
    this.upload()
  }
  /*
   upload() {
     const file = this.selectedFiles.item(0) ;
     //this.selectedFiles = undefined;
     if (file !== null)
     this.currentFileUpload = new FileUpload(file);
     this.botImageURL=false;
     this.download =true;
     const filePath =  this.uploadfilePath;
     const fileRef = this.storage.ref(filePath);
     const task = this.storage.upload(filePath, file);
     task.snapshotChanges().pipe(
         finalize(() => this.downloadURL = fileRef.getDownloadURL() )
      )
     .subscribe(image=>{
     
       this.link = fileRef.getDownloadURL().subscribe(tt=>{
         this.imagelink =tt;
         if (this.imagelink)
         this.urlImageCard.emit(this.imagelink);
       });
     })
   }
   */
  upload() {
    const file = this.selectedFiles?.item(0);

    if (!file) return;

    this.currentFileUpload = new FileUpload(file);
    this.botImageURL = false;
    this.download = true;
    this.isUploading = true;
    const filePath = `${this.uploadfilePath}/${file.name}`;
    const fileRef = this.storage.ref(filePath);

    const task = this.storage.upload(filePath, file);

    task.percentageChanges().subscribe(percentage => {
      this.progress.percentage = Math.round(percentage ? percentage : 0);
    });

    task.snapshotChanges()
      .pipe(
        finalize(() => {
          fileRef.getDownloadURL().subscribe(url => {
            this.imagelink = url;
            this.isUploading = false;
            this.urlImageCard.emit(url);
          });
        })
      )
      .subscribe();
  }

}
